module.exports = __webpack_public_path__ + "static/media/04ilustracion.9a182d85.png";